import { ModalPresentationProps } from "@insite/mobius/Modal";
import { css } from "styled-components";

export const modalSmallProps: ModalPresentationProps = {
    sizeVariant: "small",
    cssOverrides: {
        modalTitle: css`
            ${props => props.theme.modal?.defaultProps?.cssOverrides?.modalTitle}
            padding: 10px 20px;
        `,
        modalContent: css`
            ${props => props.theme.modal?.defaultProps?.cssOverrides?.modalContent}
            padding: 20px;
        `,
    },
    closeButtonIconProps: {
        size: 16,
    },
};
